import React, { useContext, useState } from 'react';
import { message, Form, Input, Select, Button, Space, Checkbox } from 'antd';
import { Context } from '../../../defaults';
import {
  createClasses,
  getInstitutionById,
  getInstitutionStudentsWithoutClasses,
  getInstitutionTeachersWithoutClasses,
} from '../../../actions';
import { integerRegex, studyYearRegex, subjectsRegex } from '../../../common';
import { MaskedInput } from 'antd-mask-input';

export function ClassesAdd({ institutions, languagesType, setAdded, setActive }) {
  const [form] = Form.useForm();
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState('');
  const [studentsIsActive, setStudentsIsActive] = useState(false);
  const [teachersIsActive, setTeachersIsActive] = useState(false);
  const [studyYear, setStudyYear] = useState();
  const [currentRegExp, setCurrentRegExp] = useState('');
  const [currentInstitute, setCurrentInstitute] = useState('');
  const { dictionary, language, setLoading } = useContext(Context);
  const requiredMessage = dictionary?.FillTheField[language];

  const initialState = {
    institutionId: null,
    letter: '',
    year: '',
    yearOfStudy: '',
    teachersId: null,
    studentsId: [],
  };

  const onCreateClasses = () => {
    setLoading(true);
    form
      .validateFields()
      .then((response) => {
        createClasses(response)
          .then(() => {
            setLoading(false);
            setAdded(true);
            setActive('2');
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            form.setFieldsValue(initialState);
          })
          .catch(() => {
            message.error(dictionary?.SomethingWentWrong[language], 4);
            setLoading(false);
          });
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e.target.value;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: 'Начало года обучения не может быть больше чем конец года обучения',
        };
      }
      if (
        Number.isInteger(parseInt(years[0])) &&
        Number.isInteger(parseInt(years[1])) &&
        years[1] - years[0] !== 1
      ) {
        return {
          validateStatus: 'error',
          help: 'Начало года обучения должно быть минимум 1 год ниже',
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!value) {
        return { validateStatus: 'error', help: requiredMessage };
      } else {
        return { validateStatus: 'success', help: null };
      }
    }
  }

  const onChangeInstitute = (e, data) => {
    setStudents([]);
    setTeachers('');
    form.setFieldsValue({ teachersId: '', studentsId: [] });
    if (data && data.value) {
      getInstitutionStudentsWithoutClasses(data.value).then(({ data }) => setStudents(data));
      getInstitutionTeachersWithoutClasses(data.value).then(({ data }) => setTeachers(data));
    }
    getInstitutionById(data.value).then(({ data }) => {
      setCurrentInstitute(data);
      setCurrentRegExp(subjectsRegex(data.studyYearFrom, data.studyYearTo));
    });
  };

  return (
    <Form
      layout="horizontal"
      labelCol={{ span: 7 }}
      form={form}
      name="nest-messages"
      initialValues={initialState}>
      <Form.Item
        name="institutionId"
        label={dictionary?.Institution[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select
          onChange={onChangeInstitute}
          placeholder={dictionary?.Institution[language]}
          allowClear
          showSearch
          style={{ width: 625 }}
          filterOption={(input, option) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}>
          {institutions &&
            institutions.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        name="year"
        label={dictionary?.Year[language]}
        rules={[
          { required: true, message: requiredMessage },
          { pattern: integerRegex, message: dictionary?.OnlyNumber[language] },
          { max: 2, message: 'Не больше двухзначных чисел' },
          {
            pattern: currentRegExp,
            message: dictionary?.InvalidStudyYear[language].replace(
              'diapasone',
              `${currentInstitute.studyYearFrom}-${currentInstitute.studyYearTo}`,
            ),
          },
        ]}>
        <Input style={{ width: 625 }} />
      </Form.Item>
      <Form.Item
        name="letter"
        label={dictionary?.Letter[language]}
        rules={[
          { required: true, message: requiredMessage },
          //{ pattern: letterRegex, message: dictionary?.OnlyLetter[language] },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] },
        ]}>
        <Input style={{ width: 625 }} />
      </Form.Item>
      <Form.Item
        label={dictionary?.YearStudy[language]}
        name="yearOfStudy"
        rules={[{ required: true, message: requiredMessage }]}
        {...rulesForStudyYear(studyYear)}>
        <MaskedInput
          value={studyYear}
          onChange={setStudyYear}
          mask="11/11"
          placeholder="__/__"
          style={{ width: 625 }}
        />
      </Form.Item>
      <Form.Item label={dictionary?.Students[language]} name="studentsId">
        <Space>
          <Checkbox
            onChange={(e) => setStudentsIsActive(e.target.checked)}
            checked={studentsIsActive}
            size="large"
          />
          <Select
            mode="multiple"
            placeholder={dictionary?.Students[language]}
            onChange={(ids) => form.setFieldsValue({ studentsId: ids })}
            allowClear={true}
            style={{ width: 600 }}
            disabled={!studentsIsActive}>
            {students &&
              students.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.lastName} {el.firstName} {el.middleName}
                  </Select.Option>
                );
              })}
          </Select>
        </Space>
      </Form.Item>
      <Form.Item label={dictionary?.Teacher[language]} name="teachersId">
        <Space>
          <Checkbox
            onChange={(e) => setTeachersIsActive(e.target.checked)}
            checked={teachersIsActive}
            size="large"
          />
          <Select
            placeholder={dictionary?.Teacher[language]}
            onChange={(e, data) => {
              form.setFieldsValue({ teachersId: data.value });
            }}
            allowClear={true}
            style={{ width: 600 }}
            disabled={!teachersIsActive}>
            {teachers &&
              teachers.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.lastName} {el.firstName} {el.middleName}
                  </Select.Option>
                );
              })}
          </Select>
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 12, span: 16 }}>
        <Button type="primary" htmlType="submit" onClick={() => onCreateClasses()}>
          {dictionary?.Save[language]}
        </Button>
      </Form.Item>
    </Form>
  );
}
